import { computed, inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { MealPlanModel } from '@models/meal-plan/meal-plan.model';
import { HttpService } from './http.service';

const STORAGE_KEY = 'selected_meal_plan';

@Injectable({
  providedIn: 'root',
})
export class MealPlanService {
  private readonly mealPlansApi = !environment.isFullOnline
    ? `${environment.caisseApiUrl}/admissions`
    : `${environment.caisseApiUrl}/company_menu_options`;
  private readonly httpService = inject(HttpService);

  private readonly selectedMealPlan = signal<MealPlanModel | null>(this.#restore());
  readonly currentMealPlan = computed(() => this.selectedMealPlan());

  getMealPlans(userId: number, enterpriseId: number): Observable<MealPlanModel[]> {
    return this.httpService.get<MealPlanModel[]>(
      !environment.isFullOnline
        ? `${this.mealPlansApi}/user/${userId}/enterprise/${enterpriseId}`
        : `${this.mealPlansApi}/by_user/${userId}/${enterpriseId}`,
    );
  }

  setMealPlan(mealPlan: MealPlanModel): void {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(mealPlan));
    this.selectedMealPlan.set(mealPlan);
  }

  clearMealPlan(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    this.selectedMealPlan.set(null);
  }

  #restore(): MealPlanModel | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as MealPlanModel;
    } catch {
      return null;
    }
  }
}
